





































































import Vue from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { TCollectionIcons } from '@/types';
import publisherIcons from './publisherIcons';
import { IWidgetParams } from '@/types/publisher/inventory';

export default Vue.extend({
  name: 'PlacementTypeBanner',
  components: {
    FieldInput,
  },
  props: {
    placementId: {
      type: String,
      required: true,
    },
  },
  computed: {
    widgetParams(): IWidgetParams {
      return this.$store.getters['publisher/getPlacementWidgetParams'].byId[
        this.placementId
      ];
    },
    publisherIcons(): TCollectionIcons {
      return publisherIcons;
    },
  },
  methods: {
    changeEvent(propName: string, value: string | number): void {
      const newDataWithId = {
        id: this.placementId,
        propName,
        value,
      };

      this.$store.dispatch(
        'publisher/updatePlacementWidgetParamsData',
        newDataWithId
      );
    },
  },
});
